export const DEFAULT_API_URL = 'https://app.sminy.ai';

type PageLocation = Pick<Location, 'hostname' | 'protocol'>;

function formatUrl(url: URL, rawUrl: string): string {
  const formattedUrl = url.toString();

  if (!rawUrl.endsWith('/') && url.pathname === '/' && !url.search && !url.hash) {
    return formattedUrl.replace(/\/$/, '');
  }

  return formattedUrl;
}

export function resolveApiUrl(
  configuredApiUrl: string | undefined,
  pageLocation?: PageLocation
): string {
  const rawApiUrl = configuredApiUrl?.trim() || DEFAULT_API_URL;

  let apiUrl: URL;
  try {
    apiUrl = new URL(rawApiUrl);
  } catch {
    return rawApiUrl;
  }

  if (
    apiUrl.protocol === 'http:' &&
    pageLocation?.protocol === 'https:' &&
    apiUrl.hostname === pageLocation.hostname
  ) {
    apiUrl.protocol = 'https:';
  }

  return formatUrl(apiUrl, rawApiUrl);
}
